import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TextDesignModels } from '@medsurf/flat-models';

@Component({
    selector: 'medsurf-design-input-text',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './text.input.design.html',
    styleUrls: ['./text.input.design.scss'],
    standalone: false
})
export class TextInputDesign {
  @Input() formField = true;
  @Input({ required: true }) name!: string;
  @Input() inputType = 'text';
  @Input() inputClass: TextDesignModels.TextDesignClass = TextDesignModels.TextDesignClass.DEFAULT;
  @Input() placeholder = "";
  @Input() label?: string;
  @Input() inputGroup = false;
  @Input() disabled = false;
  @Input({ required: true }) model!: string;
  @Output() valueChange = new EventEmitter<Event>();
}
